import { memo } from 'react';
import { utf16Count } from '../../InteractiveAction.functions';

type tUTF16CounterProps = {
  value: string | undefined | null;
  max: number;
};

// Live character counter for Meta-enforced limits. Shows warn color at 90%
// and error color at 100% to match the seller's intuition about "running out
// of space". UTF-16 code units (JS `.length`) — do NOT switch to grapheme
// count or the server will reject at a different threshold than the UI shows.
// Memoized because the composer renders 7+ instances and Formik re-renders
// the whole subtree on every keystroke — props are primitives so the memo
// never gets fooled by reference changes.
function UTF16Counter(props: tUTF16CounterProps) {
  const count = utf16Count(props.value);
  const pct = props.max === 0 ? 0 : count / props.max;
  const modifier =
    count > props.max ? '--error' : pct >= 0.9 ? '--warn' : '';
  return (
    <span
      className={`InteractiveAction__Field__Counter InteractiveAction__Field__Counter${modifier}`}
    >
      {count} / {props.max}
    </span>
  );
}

export default memo(UTF16Counter);
